import { useCallback } from 'react';

import { telegramClientApi } from '@/shared/api';

/**
 * Hook for collecting analytics events.
 * Sends events to both the backend API and Google Analytics 4.
 */
export const useCollect = () => {
  const collect = useCallback(async (payload: any) => {
    try {
      await telegramClientApi.collect(payload);
    } catch (error) {
      console.error('Failed to collect analytics event via backend', error);
    }

    // Send to GA4 if gtag is available
    if (typeof window.gtag === 'function') {
      // Convert payload to GA4 event format
      // GA4 event names should be lowercase with underscores
      let eventName = 'custom_event';
      const eventParams: Record<string, any> = {};

      // Extract event name from payload
      if (payload.url) {
        eventName = 'page_view';
        eventParams.page_path = payload.url;
        eventParams.page_location = window.location.href;
        eventParams.page_title = document.title;
        if (payload.tab) {
          eventParams.tab = payload.tab;
        }
      } else if (payload.scene && payload.button_clicked) {
        eventName = 'button_click';
        eventParams.scene = payload.scene;
        eventParams.button_name = payload.button_clicked;
      } else if (payload.modal && payload.button_clicked) {
        eventName = 'modal_button_click';
        eventParams.modal_name = payload.modal;
        eventParams.button_name = payload.button_clicked;
      } else {
        // Generic event - include all payload properties
        Object.assign(eventParams, payload);
      }

      // Send event to GA4
      window.gtag('event', eventName, eventParams);
    }
  }, []);

  return { collect };
};
